import Image from 'app/Components/Shared/Image/image';
import React from 'react'
import { connect } from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {setShowPopUp} from '../OrganizationPortalSlice';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';



function OrganizationMsgPopup({messageContent,setShowPopUp,submitClick}) {

  const handleSubmit=()=>
  {
    setShowPopUp(false);
    if(messageContent.redirectPath=="selfcareLobby"){
        EpiContext.navigateTo(Config.lobbyUrl);
       return;
    }else if(messageContent.redirectPath=="") {
      location.reload()
    }else{
    submitClick && submitClick();
    }
  }

  return (
    <div className='org-popup-container'>
      <Image className='icon' src={messageContent.icon} />

      <p className='popup-title M_Title'  dangerouslySetInnerHTML={{ __html: messageContent.title }} />
      <p className='popup-subTitle' dangerouslySetInnerHTML={{ __html: messageContent.subTitle }}/>

          {messageContent.buttonText &&
          <BtnSubmit text={messageContent.buttonText} onclick={() =>handleSubmit()}></BtnSubmit>
        }
    </div>
  )
}

const mapStateToProps = (state) => ({
  messageContent:state.organizationPortal.messageContent
});

const mapDispatchToProps = {
  setShowPopUp
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationMsgPopup);
